import React, { useEffect } from 'react';
// import { DropdownMenu, DropdownToggle, UncontrolledDropdown,DropdownItem } from 'reactstrap';
import {BiUserCircle} from "react-icons/bi"; 
// import { useOktaAuth } from '@okta/okta-react';
import { IoSettingsOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";
import { MdOutlineLogout} from "react-icons/md";
import { RiFileInfoLine } from "react-icons/ri";
// import { useHistory } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import file from "./changeLog.md";
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable'; 
import ChangeLog from './changeLog';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';
import { clearQuoteSearch } from '../redux/project/projActions';
// import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
function PaperComponent(props) {
  return (
      <Draggable
          handle="#draggable-dialog-title"
          // cancel={'[class*="MuiDialogContent-root"]'}
      >
          <Paper {...props} />
      </Draggable>
  );
}

const Profile = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const location = useLocation();
  const dispatch = useDispatch();
  const profileState = useSelector((state) => state.profile);

  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isOpenVersionHistory, setIsOpenVersionHistory] = React.useState(false);
  const [markdown, setMarkdown] = React.useState("");
  const { t, i18n } = useTranslation();
  // console.log("isOpenVersionHistory", isOpenVersionHistory)
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
    // const { authState, oktaAuth } = useOktaAuth();

  const navigateToPreference = () => {
    dispatch(clearQuoteSearch());
    handleClose()
    navigate(`/preference`, { state: { from: location.pathname } })
  }
    // const history = useHistory();
    const isCorsError = (err) => (err.name === 'AuthApiError' && !err.errorCode && err.xhr.message === 'Failed to fetch');
    // const handleClick1=()=>{
    //   localStorage.removeItem('okta-token-storage')
    // }
     const exitApp = async () => {
        localStorage.removeItem('pgrid_filterModel');// clear project page filter
        localStorage.removeItem('pkgGrid_filterModel');// clear package page filter
        logout({ logoutParams: { returnTo: window.location.origin } })
        //  const basename = window.location.origin +'/'
        //  try {
        //    await oktaAuth.revokeAccessToken().catch((err) => {
        //     // console.log(err);
        //    });
        //    await oktaAuth.signOut({ postLogoutRedirectUri: basename });
        //    localStorage.removeItem('okta-original-uri-storage');
        //    localStorage.removeItem('persist:root');
        //    localStorage.removeItem('okta-cache-storage');
        //    localStorage.removeItem('okta-shared-transaction-storage');
        //  } catch (err) {
        //    if (isCorsError(err)) {
        //      setCorsErrorModalOpen(true);
        //    } else {
        //      throw err;
        //    }
        //  }
       };

       
    // useEffect(()=>{
      // const authToken = localStorage.getItem("okta-token-storage");
      // if(!authToken){
      //   localStorage.clear();
      //   exitApp();
      //   handleClose();
      //   // navigate("/login");
      // }
      // //Fetch markdow file
      // fetch(file)
      // .then((res) => res.text())
      // .then((text) => setMarkdown(text));
  // },[])

    return(
        <>
        <Dialog   maxWidth="xl" fullWidth open={isOpenVersionHistory} 
        onClose={() => setIsOpenVersionHistory(false)  } 
              
         className=" muiForm-Modal" 
         PaperComponent={PaperComponent}  aria-labelledby="draggable-dialog-title">
                <DialogTitle className="model-title" id="draggable-dialog-title" >{t('About Application')}</DialogTitle>
              
                <DialogContent>
                                   
    
          <ChangeLog />

                  {/* <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdown}</ReactMarkdown> */}

                </DialogContent>
                <DialogActions className='model-actions'>
                <Button className="cnbtn btn btn-outline-success" variant="outlined" onClick={(e) => setIsOpenVersionHistory(false)} style={{ "marginRight": "5px" }}>
                {t('Cancel')}  
                </Button>
                  <span></span>
                </DialogActions>
            </Dialog>
      <Button
        id='profset'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <BiUserCircle className='settings' />
      </Button>
      <Menu
        id='profilesettings'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
                    <MenuItem className="cmnlblfnt2 dropdown-menu dropdown-menu-end show userName Mui-disabled" ><FaRegUser style={{marginRight: '5px', fontSize: '14px'}}/>  {profileState.givenName + ' ' + profileState.familyName}</MenuItem>
             <MenuItem className="cmnlblfnt2 dropdown-menu dropdown-menu-end show" onClick={() => setIsOpenVersionHistory(true)}><RiFileInfoLine style={{marginRight: '5px', fontSize: '14px'}}/>  {t('About Application')}</MenuItem>
            {/* {location.pathname === '/' && ( */}
              <MenuItem className="cmnlblfnt2 dropdown-menu dropdown-menu-end show" onClick={() => navigateToPreference()}>
                <IoSettingsOutline style={{marginRight: '5px', fontSize: '14px'}}/>  {t('General Settings')}
              </MenuItem>
            {/* // )} */}
        <MenuItem className="cmnlblfnt2 dropdown-menu dropdown-menu-end show" onClick={() => { exitApp(); handleClose(); }}><MdOutlineLogout style={{marginRight: '5px', fontSize: '14px'}}/>  {t('Log out')} </MenuItem>
        {/* <MenuItem className="cmnlblfnt2 dropdown-menu dropdown-menu-end show" onClick={() => { handleClick1() }}>Log out</MenuItem> */}
     </Menu>
         {/* <Dropdown onChange={() => { }} >
          <DropdownToggle size='sm' >
            </DropdownToggle>
            <DropdownMenu end>
             <DropdownItem  >Log out</DropdownItem>
            </DropdownMenu>
        </Dropdown> */}
        </>
  )
}


export default Profile;